import { render, staticRenderFns } from "./SmsReminder.vue?vue&type=template&id=7b71de07&"
import script from "./SmsReminder.vue?vue&type=script&lang=ts&"
export * from "./SmsReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports